import {
  SUBMENU_ALL_SECTION,
  SUBMENU_PARAM_ACTIVE_VALUE,
  SUBMENU_PARAM_UNREAD_VALUE,
} from '../../../constants/route'

export const SUBMENU_ITEM_KEYS = {
  label: 'title',
  value: 'name',
}

export const SUBMENU_UNREAD_KEYS = {
  active: SUBMENU_PARAM_ACTIVE_VALUE,
  all: SUBMENU_ALL_SECTION,
  unread: SUBMENU_PARAM_UNREAD_VALUE,
}
